import axios from 'axios';
import config from '../config';
import { MarketingCaptureType } from '../types/MarketingCaptureType';
import DataDogInstance from '../utils/monitoring';
import { RateLimiter } from '../utils/rateLimit';

const gatewayUrl = config.APIGW_URL;

// The pre-qualify CTA awaits this event before navigating to the application
// flow, so the request is bounded: a stalled connection rejects here and the
// caller carries on rather than leaving the button pending.
const captureTimeoutMs = 5000;

export async function submitMarketingCapture(
  data: MarketingCaptureType
): Promise<void> {
  try {
    await RateLimiter.getInstance().checkRateLimit('marketingCapture');
    const response = await axios.post(`${gatewayUrl}/marketingcapture`, data, {
      headers: {
        'X-CG-AppIdentifier': 'coign-web',
      },
      timeout: captureTimeoutMs,
    });

    return response.data;
  } catch (error) {
    const isNetworkError =
      axios.isAxiosError(error) && error.message === 'Network Error';

    if (!isNetworkError) {
      DataDogInstance.getInstance().logError(
        'Failed to submit marketing capture event',
        { prospectId: data.prospectId, gatewayUrl },
        error as Error
      );
    }
    throw error;
  }
}
